import { Button, styled } from "@mui/material";

const CustomHeaderButton = styled(Button)({
  fontWeight: 500,
  textTransform: "none",
  whiteSpace: "nowrap",
  color: "white",
  borderColor: "white",
  transition: "background-color 0.2s, transform 0.2s",
  "&:hover": {
    backgroundColor: "#ffffff22",
  },
});

export default CustomHeaderButton;
